import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["RouterModel"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getRouterModel: build.query<
        GetRouterModelApiResponse,
        GetRouterModelApiArg
      >({
        query: () => ({ url: `/RouterModel` }),
        providesTags: ["RouterModel"],
      }),
      postRouterModel: build.mutation<
        PostRouterModelApiResponse,
        PostRouterModelApiArg
      >({
        query: (queryArg) => ({
          url: `/RouterModel`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["RouterModel"],
      }),
      getRouterModelById: build.query<
        GetRouterModelByIdApiResponse,
        GetRouterModelByIdApiArg
      >({
        query: (queryArg) => ({ url: `/RouterModel/${queryArg}` }),
        providesTags: ["RouterModel"],
      }),
      putRouterModelById: build.mutation<
        PutRouterModelByIdApiResponse,
        PutRouterModelByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/RouterModel/${queryArg.id}`,
          method: "PUT",
          body: queryArg.routerModelDto,
        }),
        invalidatesTags: ["RouterModel"],
      }),
      deleteRouterModelById: build.mutation<
        DeleteRouterModelByIdApiResponse,
        DeleteRouterModelByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/RouterModel/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["RouterModel"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as routerModelApi };
export type GetRouterModelApiResponse = /** status 200 OK */ RouterModelDto[];
export type GetRouterModelApiArg = void;
export type PostRouterModelApiResponse = /** status 201 Created */ number;
export type PostRouterModelApiArg = RouterModelDto;
export type GetRouterModelByIdApiResponse = /** status 200 OK */ RouterModelDto;
export type GetRouterModelByIdApiArg = number;
export type PutRouterModelByIdApiResponse = /** status 200 OK */ void;
export type PutRouterModelByIdApiArg = {
  id: number;
  routerModelDto: RouterModelDto;
};
export type DeleteRouterModelByIdApiResponse = unknown;
export type DeleteRouterModelByIdApiArg = number;
export type RouterModelDto = {
  id: number;
  name?: string | null;
  manufacturer?: string | null;
  comment?: string | null;
  isUsed: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetRouterModelQuery,
  useLazyGetRouterModelQuery,
  usePostRouterModelMutation,
  useGetRouterModelByIdQuery,
  useLazyGetRouterModelByIdQuery,
  usePutRouterModelByIdMutation,
  useDeleteRouterModelByIdMutation,
} = injectedRtkApi;
